<template>
  <div id="map-add-or-update-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie v-if="loading == 'updateAreaMapLoading' && form == null" key="create-loading"  />
        <el-row v-else key="content-loading">
          <el-row :gutter="10">
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.areaMap.areaMapAddUpdate.img") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("contentManagement.areaMap.areaMapAddUpdate.imgMsg") }}</span>
                    </div>
                    <i v-if="logoPercent > 0" class="el-icon-loading"></i>
                    <i class="el-icon-info" v-else></i>
                  </el-tooltip>
                </div>
                <div class="mage-maker" :style="{ background: form != null ? `url(${form.image})` : '' }">
                  <el-upload :class="$inputError('image', validationErrors)" :onProgress="logoProgress" class="avatar-uploader" :style="{ opacity: form.image != null ? '0' : '1' }" :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=areaMap&language=' + $i18n.locale" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" drag :show-file-list="false" :on-success="logoSuccess">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text" v-html="$t('generic.uploadText')"></div>
                  </el-upload>
                </div>
                <span class="error">{{ $errorMessage("image", validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="24" class="mt-3" v-if="form">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.areaMap.areaMapAddUpdate.title") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("contentManagement.areaMap.areaMapAddUpdate.titleMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input v-model="form.title" :class="$inputError('title', validationErrors)"></el-input>
                <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="settingsDock = !settingsDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("contentManagement.areaMap.areaMapAddUpdate.settings") }}</label>
                      <!-- <el-tooltip content="Content" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("contentManagement.areaMap.areaMapAddUpdate.settingsMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsDock">
                    <div class="custom-set-container" :class="form.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label
                            >{{ $t("contentManagement.areaMap.areaMapAddUpdate.view") }}
                            <!-- <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("contentManagement.areaMap.areaMapAddUpdate.viewMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.isActive"></el-switch>
                      </div>
                    </div>

                    <div class="custom-set-container" :class="form.enableCustomTags ? 'sactive' : ''">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.enableCustomTags ? 'fa-tags' : 'fa-tags'"></i>
                        <div class="custom-set-info">
                          <label
                            >{{ $t("contentManagement.areaMap.areaMapAddUpdate.useTags") }}
                            <!-- <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("contentManagement.areaMap.areaMapAddUpdate.useTagsMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.enableCustomTags"></el-switch>
                      </div>
                      <div class="custom-set-actions fcenter mt-3" v-show="form.enableCustomTags">
                        <CustomTag :value="form.customTags" v-if="settingsDock" :key="form.id" v-model="form.customTags"></CustomTag>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </el-row>
      </transition>
    </div>
    <div class="modal-footer" slot="footer" v-if="loading != 'updateAreaMapLoading' && form != null">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("contentManagement.areaMap.areaMapAddUpdate.close") }}</el-button>
        <template v-if="form.id != null">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash"> {{ $t("contentManagement.areaMap.areaMapAddUpdate.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'saveLoading'" :disabled="loading == 'saveLoading'" @click="save">{{ $t("contentManagement.areaMap.areaMapAddUpdate.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import HolaconLottie from "../components/HolaconLottie.vue"
import axios from "axios";
import ItemInfo from "./ItemInfo";
export default {
  components: { ItemInfo,HolaconLottie },
  name: "SpeakerAddUpdate",
  props: ["id"],
  data() {
    return {
      settingsDock: false,
      timeout: null,
      loading: false,
      form: null,
      logoPercent: 0,
      axios,
      validationErrors: [],
      showInfo: false,
    };
  },
  methods: {
    deleteItem() {
      this.$emit("deleteMe", this.form.id);
      this.$emit("closeDialog");
    },
    async save() {
      this.loading = "saveLoading";
      if ((this.timeout = null)) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await axios.post("areamap/addorupdate", this.form);
        this.validationErrors = res.data.validationErrors;
        if (res.data.alert.hasError) {
          this.$message.error(res.data.alert.message);
        } else {
          this.$message.success(res.data.alert.message);
          this.form = res.data.data.item;
          await this.$store.dispatch("getAreaMaps");
        }
        this.loading = false;
      }, 500);
    },
    logoProgress(event) {
      this.logoPercent = event.percent;
    },
    logoSuccess(response) {
      this.logoPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.image = response.data.item.url;
      }
    },
  },
  async created() {
    this.loading = "updateAreaMapLoading";
    if (this.timeout != null) clearTimeout(this.timeout);
    if (this.id != undefined && this.id != null) {
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("getAreaMap", this.id);
        if (!res.data.alert.hasError) {
          this.form = res.data.data.item;
        } else {
          this.$emit("closeMe");
        }
        this.loading = false;
      }, 500);
    } else {
      this.timeout = setTimeout(() => {
        this.form = {
          id: null,
          title: null,
          image: null,
          orderNO: 1,
          enableCustomTags: false,
          isActive: false,
          customTags: [],
        };
        this.loading = false;
      }, 500);
    }
  },
};
</script>
<style lang="less">
.registerform-input-container {
  .tag-container {
    gap: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .badge-list {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    .badger {
      border-radius: 8px;
      background-color: #f3f3f3;
      height: 20px;
      padding: 10px;
    }
  }
  .title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    label {
      font-weight: bold;
      color: black;
      margin-bottom: 0;
    }
    .title-container {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      align-items: center;
    }
  }
  display: flex;
  flex-direction: column;
  .el-input-number {
    width: 100%;
  }
}
.mage-maker {
  width: 100%;
  position: relative;
  border: 1px dashed #ccc;
  height: 250px;
  background-size: contain !important;
  background-position: center center !important;
  border-radius: 5px;
  background-repeat: no-repeat !important;
  .avatar-uploader {
    opacity: 0;
    transition: all 1s;
    &:hover {
      opacity: 1 !important;
    }
    & > .el-upload {
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 250px !important;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AreaMapAddUpdate.vue